/**
 * Monitoring API
 */

import apiClient from './client';

/**
 * Get system health status
 */
export const getSystemHealth = async () => {
  const { data } = await apiClient.get('/api/v1/monitoring/health');
  return data;
};

/**
 * Get comprehensive monitoring metrics
 */
export const getMonitoringMetrics = async () => {
  const { data } = await apiClient.get('/api/v1/monitoring/metrics');
  return data;
};

/**
 * Get active alerts
 */
export const getActiveAlerts = async () => {
  const { data } = await apiClient.get('/api/v1/monitoring/alerts');
  return data;
};

/**
 * Get API error metrics
 */
export const getApiErrors = async (hours = 24) => {
  const { data } = await apiClient.get(`/api/v1/monitoring/api-errors?hours=${hours}`);
  return data;
};

/**
 * Get workflow metrics
 */
export const getWorkflowMetrics = async () => {
  const { data } = await apiClient.get('/api/v1/monitoring/workflow-metrics');
  return data;
};
